import { ApplyComponent } from './apply.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { from } from 'rxjs';
import { MatSelectModule,MatAutocompleteModule,MatInputModule } from '@angular/material';
import { FileUploadModule } from 'primeng/fileupload';
import { FooterComponent } from '../footer/footer.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { NbCardModule, NbStepperModule,NbLayoutModule ,NbAccordionModule,NbInputModule,NbSelectModule, NbButtonModule, NbActionsModule, NbDatepickerModule, NbCheckboxModule,NbRadioModule,NbSpinnerModule } from '@nebular/theme';
//import { NbMomentDateModule } from '@nebular/moment';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { previewImg } from './dialog/transcriptpreview.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { EducationalFormComponent } from './dialog/educationalform.component';
import { NbAlertModule} from '@nebular/theme';
import { EducationalFormYearComponent } from './dialog/educationalformyearly.component';
import { addEducationalDetailsSemesterGPA } from './dialog/educationalformsemgpa.component';
//import { addEducationalDetailsSemesterPercenatge } from './dialog/educationalformsempercenatge.component';
import { addEducationalDetailsSemesterSGPI } from './dialog/educationalformsemsgpi.component';
import { addMasterEducationalDetailsSemesterSGPI } from './dialog/mastereducationalformsemsgpi.component';
import { EducationalFormBafComponent } from './dialog/educationalformbaf.component';
import {MatRadioModule} from '@angular/material/radio';
import { InternationalPhoneModule } from 'ng4-intl-phone';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EducationalFormWithoutCgpaComponent } from './dialog/educationalformWithoutCgpa.component';
import { SharedModule } from '../pages/shared-authpipe.module';
import { MatCheckboxModule } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatIconModule} from '@angular/material/icon';
import { EducationalFormPGDComponent } from './dialog/educationalformPGDiploma.component';


@NgModule({
  declarations: [ApplyComponent,FooterComponent,NavbarComponent,previewImg,EducationalFormComponent,EducationalFormWithoutCgpaComponent,EducationalFormYearComponent,addEducationalDetailsSemesterGPA,addEducationalDetailsSemesterSGPI,addMasterEducationalDetailsSemesterSGPI,EducationalFormBafComponent,EducationalFormPGDComponent],
  imports: [
    CommonModule,
    NgxDocViewerModule,
    NbSpinnerModule,
    NbCardModule,
    NbStepperModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NbLayoutModule,
    NbAccordionModule,
    FileUploadModule,
    NbInputModule,
    NbSelectModule,
    NbDatepickerModule.forRoot(),
    // NbMomentDateModule,
    MatSelectModule,
    NbButtonModule,
    NbActionsModule,
    PdfViewerModule,
    NbCheckboxModule,
    NbRadioModule,
    NbAlertModule,
    MatRadioModule,
    InternationalPhoneModule,
    ConfirmDialogModule,
    MatAutocompleteModule,
    SharedModule,
    MatInputModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    NbSpinnerModule
  ],
  exports: [
    ConfirmDialogModule,
    NbSpinnerModule
  ],
  entryComponents: [
    previewImg,
    EducationalFormComponent,
    EducationalFormYearComponent,
    addEducationalDetailsSemesterGPA,
    addEducationalDetailsSemesterSGPI,
    addMasterEducationalDetailsSemesterSGPI,
    EducationalFormBafComponent,
    EducationalFormWithoutCgpaComponent,
    EducationalFormPGDComponent

    //addEducationalDetailsSemesterPercenatge
  ]
})
export class ApplyModule { }
